import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import CropFreeIcon from "@material-ui/icons/CropFree";
import globals from "mson/lib/globals";

import cardStyle from "./cardStyle";

// import QrReader from "react-qr-reader";
import QrScanner from "qr-scanner"; // if installed via package and bundling with a module bundler like webpack or rollup
import AgentHomeScreenReminder from "../components/UI/molecules/AgentHomeScreenReminder";

class Reader extends Component {
  qrScanner = null;
  ready = null;

  constructor(props) {
    super(props);
    this.ready = props.ready;
    this.state = {
      open: true,
      codeval: "",
      // open: false,
      process: props.process || null,
      overlay: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
      },
    };
  }

  componentWillUnmount() {
    this.stopScanner();
  }
  componentDidMount() {
    const qrElement = document.getElementById("qr_scan");
    this.qrScanner = new QrScanner(qrElement, (result) => {
      this.handleScan(result);
    });
    qrElement.addEventListener("loadedmetadata", () => {
      // do the stuff for the overlay
      const overlayElems = document.getElementsByClassName("scanArea");
      if (overlayElems.length) {
        const overlay = overlayElems.item(0);
        if (overlay) {
          const smallestVideoDimension = Math.min(
            qrElement.videoWidth,
            qrElement.videoHeight
          );
          const sourceVideoRectSize = Math.round(
            (2 / 3) * smallestVideoDimension
          );
          const smallestDOMDimension = Math.min(
            qrElement.clientWidth,
            qrElement.clientHeight
          );
          const ratio = smallestVideoDimension / smallestDOMDimension;

          const sourceRectSize = sourceVideoRectSize / ratio;
          this.setState({
            overlay: {
              width: sourceRectSize,
              height: sourceRectSize,
              left: (qrElement.clientWidth - sourceRectSize) / 2,
              top: (qrElement.clientHeight - sourceRectSize) / 2,
            },
          });
        }
      }
    });

    document.getElementById("scaninput").focus();
  }
  startScanner = () => {
    if (!this.ready()) return false;
    const qrElement = document.getElementById("qr_scan");
    qrElement.style.height = "200px";
    qrElement.style.width = "400px";
    qrElement.style.opacity = "1";

    this.qrScanner.start();

    document.getElementById("iconScanButton").style.display = "none";
    document.getElementById("stopScanButton").style.display = "block";
  };
  stopScanner = () => {
    const qrElement = document.getElementById("qr_scan");
    if (qrElement) {
      qrElement.style.height = "0px";
      qrElement.style.width = "0px";
      qrElement.style.opacity = "0";

      document.getElementById("iconScanButton").style.display = "block";
      document.getElementById("stopScanButton").style.display = "none";
    }
    this.qrScanner.stop();
  };

  handleCodeChange = async (cVal) => {
    return this.onCodeChange(cVal.target.value);
  };

  onCodeChange = async (code) => {
    if (code !== this.state.codeval) {
      this.setState({ codeval: code });
      if (code.length >= 64) {
        return await this.state.process(code);
      }
    } else {
      return false;
    }
  };
  handleScan = async (data) => {
    if (data) {
      if (data.length === 64) {
        this.qrScanner.pause();
        const result = await this.onCodeChange(data);
        if (result) {
          this.stopScanner();
        } else {
          this.qrScanner.start();
        }
      }
    }
  };
  handleError = (err) => {
    console.error("error: %o", err);
  };

  handleOpen = () => {
    this.setState({
      open: true,
    });
    this.startScanner();
  };
  handleCancel = () => {
    this.setState({
      open: false,
    });
    this.stopScanner();
  };
  loadSearch = () => {
    this.qrScanner.stop();
    globals.redirect("/search");
  };
  clearCode = () => {
    this.setState({ codeval: "" });
  };
  render() {
    return (
      <Grid container direction="row" spacing={10} justifyContent="center">
        <Grid item key="blank" xs={12} sm={8} md={8} lg={4}>
          <Paper></Paper>
        </Grid>
        <Grid item key="scan" xs={12} sm={8} md={8} lg={4}>
          <Card
            style={{
              height: "500px",
              width: "500px",
              margin: "auto",
              ...cardStyle,
            }}
          >
            <CardContent>
              <>
                <Typography gutterBottom variant="h5" component="h2">
                  Scan QR Code
                </Typography>
                <div style={{ position: "relative" }}>
                  <video
                    // Camera wont be rendered if its hidden on mount, thus using 0 sizes instead of display: none
                    height="0px"
                    width="0px"
                    style={{
                      opacity: "0",
                      border: "1px solid black",
                      margin: "auto",
                      padding: "0",
                      transform: "scaleX(-1)",
                    }}
                    playsInline=""
                    disablePictureInPicture=""
                    id="qr_scan"
                  ></video>
                  {this.state.open ? (
                    <div
                      className="scanArea"
                      style={{
                        position: "absolute",
                        width: this.state.overlay.width,
                        height: this.state.overlay.height,
                        top: this.state.overlay.top,
                        left: this.state.overlay.left,
                      }}
                    >
                      <svg
                        className="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        style={{
                          textAlign: "center",
                          color: "rgb(0, 255, 0)",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M0 1v4h1V1h4V0H1c-0.5 0 -1 0.5 -1 1zm0,22v-4h1v4h4v1h-4c-0.5,0 -1,-0.5 -1-1zm24,0v-4h-1v4h-4v1h4c0.5,0 1,-0.5 1,-1zm0,-22v4h-1v-4h-4v-1h4c0.5,0 1,0.5 1,1z"></path>
                      </svg>
                    </div>
                  ) : null}
                </div>
                <IconButton
                  id="iconScanButton"
                  style={{
                    margin: "auto",
                    textAlign: "center",
                    width: "400px",
                  }}
                  aria-label="close"
                  color="inherit"
                  onClick={this.handleOpen}
                  variant="contained"
                >
                  <CropFreeIcon
                    style={{
                      margin: "auto",
                      textAlign: "center",
                      width: "400px",
                      fontSize: "200px",
                    }}
                  />
                </IconButton>
                <div
                  style={{
                    margin: "auto",
                    textAlign: "center",
                    width: "400px",
                  }}
                >
                  <TextField
                    value={this.state.codeval}
                    id="scaninput"
                    // style={{ width: "100%" }}
                    onChange={this.handleCodeChange}
                  ></TextField>
                  <Button
                    disabled={this.state.codeval === ""}
                    onClick={() => {
                      this.clearCode();
                    }}
                  >
                    Reset
                  </Button>
                </div>
              </>
            </CardContent>
            <CardActions>
              <Grid>
                <Grid item sm={4} md={6} lg={12}>
                  <Button
                    id="stopScanButton"
                    size="small"
                    color="primary"
                    onClick={this.handleCancel}
                    style={{ display: "none" }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </CardActions>
          </Card>
        </Grid>
        <Grid item key="reminder" xs={12} sm={8} md={8} lg={4}>
          <AgentHomeScreenReminder />
        </Grid>
      </Grid>
    );
  }
}

export default Reader;
